import React, { useEffect, useRef } from "react";
import Loader from "../Loader";

const CustomModal = ({ show, setShow, children, title, headerContent = <></>, extraClass, isLoading, onClose }) => {
  const modalRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setShow(false); 
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setShow]);

  return (
    <div>
      {show && (
        <div
          className={`common-popup conduct-treatment-appointment popup-common-class fade ${show ? "show" : ""}`}
        >
          {isLoading && <div className="custm-loader">
            <Loader/>
          </div>}
          <div className="common-popup-outer">
            <div className="common-popup-inner">
              <div className={`common-popup-box animate-box ${extraClass}`} ref={modalRef}>
                <div className="common-popup-head" style={{ border: '1px solid rgb(238, 238, 238)' }}>
                  <h2 className="section-title">{title}</h2>
                  <div
                    className="common-pop-close"
                    onClick={() => {
                      setShow(false)
                      if(onClose) {
                        onClose();
                      }
                    }} // Close modal when clicking the close button
                  >
                    <img src="/assets/img/exit.png" alt="close" />
                  </div>
                  <div>{headerContent}</div>
                </div>
                <div className="">{children}</div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomModal;
